import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const ParameterVisual = ({parameter}) => { 
    let diff = parameter.max - parameter.min;
    let ratio = (parameter.get(true) - parameter.min) / diff;
    let style = {
        backgroundColor: colors.getColorForHash(parameter.name),
        height: 20 * ratio
    };

    return (
        <div style={style} className="parameter-visual">
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      value: state.effects.effectParameters[props.parameter.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterVisual);
